<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">设置高度时长</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">

        <el-form :model="addForm" :rules="rules" ref="addForm">
          <el-row>
            <el-col :span="12" class="item">
              <el-form-item label="高度(2～3.2米)" required prop="height">
                <el-input v-model="addForm.height"  placeholder="输入高度，默认：2.4"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="item">
              <el-form-item label="报警时间（10～255整数）" required prop="alarmTime">
                <el-input v-model="addForm.alarmTime" placeholder="输入时间，默认：10"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="item">
              <el-form-item label="驻留时间阀值(分钟)">
                <el-time-select style="width: 100%;" required prop="duration"
                                v-model="addForm.duration"
                                :clearable="false"
                                :picker-options="{
                      start: '00:10',
                      step: '00:20',
                      end: '05:00'
                    }" placeholder="选择时长，默认：[03:00]">
                </el-time-select>

              </el-form-item>
            </el-col>

          </el-row>

        </el-form>

      </div>
      <div class="modal-footer">
        <el-button :loading="loading" type="primary" @click="confirm('addForm')">设置</el-button>
      </div>
    </div>

  </div>
</template>

<script>

import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";


export default {
  name: 'Add',
  data() {
    return {
      loading: false,

      addForm:{
        timeStr:timeStr,
        sign:'',

        deviceQLFallCode:'',
        height:'2.4',
        alarmTime:'10',
        duration:'03:00',

      },

      rules:{
        height:[
          { required: true, message: '请输入高度', trigger: 'blur' },
        ],
        alarmTime:[
          { required: true, message: '请输入报警时间', trigger: 'blur' }
        ],
        duration:[
          { required: true, message: '请选择时长', trigger: 'blur' }
        ],

      }


    }
  },
  components: {

  },
  methods: {
    init(row){
      this.$refs.addForm.resetFields();

      this.addForm.deviceQLFallCode = row.deviceQLFallCode;
      this.addForm.height=row.height;
      this.addForm.alarmTime=row.alarmTime;
      this.addForm.duration = row.duration;

    },

    closeSelf() {
      this.$emit("closeSetHeightDuration");
    },


    confirm(addForm){
      this.$refs[addForm].validate((valid) => {
        if(valid){
          this.addSubmit();
        }else {
          console.log('error submit!!');
          return false;
        }
      })

    },

    addSubmit(){

      if(this.loading){
        return;
      }else{
        this.loading = true;
      }

      this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);

      this.addForm.duration = this.addForm.duration+":00";

      this.$axios({
        method: 'post',
        url: this.$deviceUrl+"DeviceQLFall/SetHeightDuration",
        data: this.addForm
      }).then((response) => {
        this.loading = false;
        if (response.data.error == 0) {
          this.$emit("closeSetHeightDuration");
          //this.$emit("getList");

          this.$message.success("设置成功")

        }else if(response.data.error == 1){
          this.$message.error(response.data.message)
        }

      })
    },


  }
}

</script>


<style lang="scss" scoped>

</style>
